/**
 * Etiquetas amigables para los campos de filtro de segmentos.
 * Compartido entre el chat de creación (SegmentCreateAIPage) y el detalle
 * del segmento (SegmentDashboardPage) para no mostrar nombres crudos de BD
 * como "daysSinceLastOrder". (Audit V4-15)
 */
export const FIELD_LABELS: Record<string, string> = {
    totalOrders: "Total pedidos",
    totalSpent: "Total gastado",
    avgTicket: "Ticket promedio",
    daysSinceLastOrder: "Días sin pedir",
    daysSinceFirstOrder: "Antigüedad",
    localId: "Sucursal",
    tags: "Etiquetas",
    birthMonth: "Mes cumpleaños",
    gender: "Género",
    age: "Edad",
    cartAbandonedAt: "Carrito abandonado",
    cartValue: "Valor carrito",
};
